import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

// Web CRM interface language selector. Lists ONLY languages that have a real dictionary
// (LANGUAGE_OPTIONS from the i18n layer). Selection persists via LanguageContext (localStorage).
// Affects static UI chrome only — never backend/user content.
const LanguageSelector = ({ className = '' }) => {
  const { language, setLanguage, options, t } = useLanguage();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <Globe className="h-4 w-4 text-gray-500 shrink-0" aria-hidden="true" />
      <label htmlFor="crm-language-select" className="sr-only">
        {t('common.language')}
      </label>
      <select
        id="crm-language-select"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        aria-label={t('common.language')}
        className="flex-1 text-sm bg-white border border-gray-200 rounded-md px-2 py-1.5 text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-300 cursor-pointer"
      >
        {options.map((opt) => (
          <option key={opt.code} value={opt.code}>
            {opt.nativeName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
